import { ToastrService } from "ngx-toastr";
import { Injectable } from "@angular/core";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class AlertsService {
  constructor(private _toastr: ToastrService) {}

  showDownloadSuccess() {
    Swal.close();
    Swal.fire({
      title: "Descargado",
      text: "El archivo se descargó correctamente",
      icon: "success",
      timer: 2000,
      timerProgressBar: true,
      showConfirmButton: false,
    });
  }

  showDownloadError() {
    Swal.close();
    Swal.fire({
      title: "Error",
      text: "Error al descargar el archivo",
      icon: "error",
      timer: 2000,
      timerProgressBar: true,
      showConfirmButton: false,
    });
  }

  showDownloadQuestion() {
    return Swal.fire({
      title: "Descargar",
      text: "¿Desea descargar todos los mensajes?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Descargar",
      cancelButtonText: "Cancelar",
    });
  }

  showFileDownloadQuestion() {
    return Swal.fire({
      title: "Descargar",
      text: "¿Desea descargar el archivo?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Descargar",
      cancelButtonText: "Cancelar",
    });
  }

  showDownloadLogQuestion() {
    return Swal.fire({
      title: "Descargar",
      text: "¿Desea descargar bitácora?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Descargar",
      cancelButtonText: "Cancelar",
    });
  }

  showDownloadInvoiceQuestion() {
    return Swal.fire({
      title: "Descargar",
      text: "¿Desea descargar facturas?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Descargar",
      cancelButtonText: "Cancelar",
    });
  }

  showDownloadPlanConsumptionQuestion() {
    return Swal.fire({
      title: "Descargar",
      text: "¿Desea descargar todos los registros de consumo?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Descargar",
      cancelButtonText: "Cancelar",
    });
  }

  showDownloadInfo() {
    Swal.fire({
      title: "Descargando...",
      text: "El archivo se está generando y se descargará en breve.",
      icon: "info",
      timerProgressBar: true,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });
  }

  hideLoading() {
    Swal.hideLoading();
  }

  showOldBrowserAlert() {
    this._toastr.show(
      "Versión de navegador antiguo detectada, es posible que algunas características no funcionen correctamente.",
      "Advertencia",
      {
        timeOut: 15000,
        positionClass: "toast-top-right",
        closeButton: true,
        progressBar: true,
        progressAnimation: "increasing",
        enableHtml: true,
        toastClass: "ngx-toastr toast toast-warning",
        titleClass: "toast-title",
        messageClass: "toast-message",
        tapToDismiss: false,
      }
    );
  }

  async showExitWarning() {
    const { isConfirmed } = await Swal.fire({
      title: "¿Quieres salir de esta página?",
      text: "Se cancelará el envío de este archivo!!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Si, salir de la página",
      cancelButtonText: "Continuar con el envío",
      width: 600,
    });

    return isConfirmed;
  }

  async showCancelSend() {
    const { isConfirmed } = await Swal.fire({
      title: "¿Estás seguro que quieres cancelar el envío?",
      text: "Se cancelará el envío de este archivo!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Cancelar envío",
      cancelButtonText: "Continuar con el envío",
      width: 600,
    });

    return isConfirmed;
  }

  async showDeclineSend(name: string) {
    const { isConfirmed } = await Swal.fire({
      title: "¿Estás seguro de que quieres rechazar el envío?",
      text: `Se rechazará el envío de "${name}"`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Si, rechazar",
      cancelButtonText: "No",
      width: 600,
    });

    return isConfirmed;
  }
}
